import { Button } from '@lendi-ui/button';
import InfoOutline from '@lendi-ui/icon/InfoOutline';
import Modal from '@lendi-ui/modal';
import { Body } from '@lendi-ui/typography';

import { FunnelGrid, FunnelGridUnit } from '@funnels/ui-components';

type NavigationBlockerModalProps = {
  isVisible: boolean;
  onHide: () => void;
  hasErrors: boolean;
  showDiscardButton: boolean;
  onReviewErrors: () => void;
  onSaveChanges: () => void;
  onDiscardChanges: () => void;
};

export const NavigationBlockerModal = ({
  isVisible,
  onHide,
  hasErrors,
  onReviewErrors,
  onSaveChanges,
  onDiscardChanges,
  showDiscardButton,
}: NavigationBlockerModalProps) => {
  return (
    <Modal role="dialog" isVisible={isVisible} size="lg" onHide={onHide} isHeaderFixed={true}>
      <Modal.Header title={hasErrors ? 'Attention Required' : 'Unsaved Changes'} size="xs" />
      <Modal.Content>
        <FunnelGrid direction="row">
          {hasErrors && (
            <FunnelGridUnit size={1 / 10}>
              <InfoOutline color="warn.500" width="39px" height="39px" />
            </FunnelGridUnit>
          )}
          <FunnelGridUnit size={9 / 10}>
            {hasErrors ? (
              <Body align="left">
                You have unsaved changes, but there seems to be an issue with the information entered.{' '}
                <strong>Correct the errors before saving</strong>.
              </Body>
            ) : (
              <Body align="left">
                You have unsaved changes.
                <br />
                Do you want to save them before you leave this page?
              </Body>
            )}
          </FunnelGridUnit>
        </FunnelGrid>
      </Modal.Content>
      <Modal.Footer>
        <FunnelGrid direction="row">
          {showDiscardButton && (
            <>
              <FunnelGridUnit size={1 / 2}>
                <Button variant="secondary" onClick={onDiscardChanges} isFullWidth>
                  Discard changes
                </Button>
              </FunnelGridUnit>
              <FunnelGridUnit size={1 / 2}>
                <Button variant="primary" onClick={hasErrors ? onReviewErrors : onSaveChanges} isFullWidth>
                  {hasErrors ? 'Review Errors' : 'Save Changes'}
                </Button>
              </FunnelGridUnit>
            </>
          )}
          {!showDiscardButton && (
            <>
              <FunnelGridUnit size={1}>
                <Button variant="primary" onClick={hasErrors ? onReviewErrors : onSaveChanges} isFullWidth>
                  {hasErrors ? 'Review Errors' : 'Save Changes'}
                </Button>
              </FunnelGridUnit>
            </>
          )}
        </FunnelGrid>
      </Modal.Footer>
    </Modal>
  );
};
